import { render, staticRenderFns } from "./communicationDashboardPopups.vue?vue&type=template&id=4f2901b6&scoped=true"
import script from "./communicationDashboardPopups.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPopups.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPopups.vue?vue&type=style&index=0&id=4f2901b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2901b6",
  null
  
)

export default component.exports